import { SELECT_LAYERS_TAB, SIDEBAR_EXPAND, SIDEBAR_COLLAPSE } from '../common/actionTypes';

const defaultState = {
  selectedTab: 'forests',
  isOpen: true,
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case SELECT_LAYERS_TAB:
      return {
        ...state,
        selectedTab: action.tab,
      };

    case SIDEBAR_EXPAND:
      return {
        ...state,
        isOpen: true,
      };

    case SIDEBAR_COLLAPSE:
      return {
        ...state,
        isOpen: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sidebarReducer.js